import * as React from "react";
import { Typography } from "@mui/material";
import { TypographyProps } from "@mui/material";

import "./styles.scss";

interface CustomTypographyProps extends TypographyProps {
  component?: React.ElementType;
  children?: React.ReactNode;
}

const classNameBase = "scd-typography";

const CustomTypography = ({
  children,
  component = "div",
  ...other
}: CustomTypographyProps): React.JSX.Element => {
  return (
    <Typography
      component={component}
      classes={{
        root: `${classNameBase}-wrapper`,
        h1: `${classNameBase}-h1`,
        h2: `${classNameBase}-h2`,
        h3: `${classNameBase}-h3`,
        h4: `${classNameBase}-h4`,
        h5: `${classNameBase}-h5`,
        h6: `${classNameBase}-h6`,
        subtitle1: `${classNameBase}-subtitle1`,
        subtitle2: `${classNameBase}-fineprint`,
        body1: `${classNameBase}-body1`,
        body2: `${classNameBase}-body2`,
      }}
      {...other}
    >
      {children}
    </Typography>
  );
};

export default CustomTypography;
